import { normalize } from 'polished';
import { createGlobalStyle } from 'styled-components';

import { Black, White } from './colours';
import './font-faces.css';
import { Regular } from './fonts';

const GlobalStyle = createGlobalStyle`

  ${normalize()}
  
  *,
  *:before,
  *:after {
    box-sizing: border-box;
    position: relative;
  }
     
  html,
  body,
  #root {  
    font-family: ${Regular}, 'Arial', 'Helvetica', sans-serif;
    font-size: 14px;
    line-height: 1.5rem;
    
    margin: 0;
    padding: 0;
    
    height: 100%;
    width: 100%;
    
    background: ${White};
    color: ${Black};
  }
`;

export { GlobalStyle };
